import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import AdminActivityHistory from './AdminActivityHistory'
import AdminTransactionHistory from './AdminTransactionHistory'
import AdminWalletHistory from './AdminWalletHistory'
import AdminWalletList from './AdminWalletList'
import AdminIPList from './AdminIPList'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminRecordDetailsPage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '거래내역',
			link: '/record/transaction-details',
		},
		{
			title: '활동내역',
			link: '/record/activity-history',
		},
		{
			title: '계좌이력',
			link: '/record/wallet-history',
		},
		{
			title: '계좌목록',
			link: '/record/wallet-list',
		},
		{
			title: '아이피목록',
			link: '/record/ip-list',
		},
	]

	const renderContent = () => {
		switch (url) {
			case '/record/transaction-details':
				return <AdminTransactionHistory title={'거래내역'} />
			case '/record/activity-history':
				return <AdminActivityHistory title={'활동내역'} />
			case '/record/wallet-history':
				return <AdminWalletHistory title={'계좌이력'} />
			case '/record/wallet-list':
				return <AdminWalletList title={'계좌목록'} />
			case '/record/ip-list':
				return <AdminIPList title={'아이피목록'} />
			default:
				return <AdminTransactionHistory title={'거래내역'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>ADMIN - 이력조회</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
